const API_URL = process.env.REACT_APP_API_URL;

export async function getPerfilLoja(storeId) {
  try {
    const response = await fetch(`${API_URL}/perfil/${storeId}`);
    if (!response.ok) throw new Error('Erro ao buscar perfil');
    const data = await response.json();
    return data;
  } catch (err) {
    return null;
  }
}
